'use client'

import { type FC } from 'react'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'
import { ProductSearchResultItemCounterLabel } from './ProductSearchResultItemLabels/ProductSearchResultItemCounterLabel'
import { ProductSearchResultItemGenericLabel } from './ProductSearchResultItemLabels/ProductSearchResultItemGenericLabel'
import { ProductSearchResultItemNowLabel } from './ProductSearchResultItemLabels/ProductSearchResultItemNowLabel'
import { ProductSearchResultItemPrescriptionRequiredLabel } from './ProductSearchResultItemLabels/ProductSearchResultItemPrescriptionRequiredLabel'
import { ProductSearchResultItemPromotionLabelRenderer } from './ProductSearchResultItemLabels/ProductSearchResultItemPromotionLabelRenderer'
import { ProductSearchResultItemRedPointsLabel } from './ProductSearchResultItemLabels/ProductSearchResultItemRedPointsLabel'
import { ProductSearchResultItemSellerPromotionLabel } from './ProductSearchResultItemLabels/ProductSearchResultItemSellerPromotionLabel'
import { ProductSearchResultItemSellerSponsoredLabel } from './ProductSearchResultItemLabels/ProductSearchResultItemSellerSponsoredLabel'
import {
  ProductSearchResultItemVolumePricingLabel,
  useProductSearchShouldRenderVolumePricingLabel,
} from './ProductSearchResultItemLabels/ProductSearchResultItemVolumePricingLabel'
import { useProductSearchResultItemLabels } from './ProductSearchResultItemLabels/useProductSearchResultItemLabels'
import { useResultItemLabelReducer } from './useResultItemLabelReducer'

export const ProductSearchResultItemLabelList: FC = () => {
  const { algoliaRecord } = useProductSearchResultItemContext()

  const resultItemLabels = useProductSearchResultItemLabels({ algoliaRecord })

  const { counterRef, hiddenLabelsCounter, ref } = useResultItemLabelReducer()

  const renderVolumeBasedPricingLabel =
    useProductSearchShouldRenderVolumePricingLabel()

  return (
    <div className="absolute inset-x-3 top-0 z-10 flex -translate-y-1/2 pr-12">
      <div
        className="flex max-h-[28px] flex-wrap items-end gap-3 overflow-hidden"
        ref={ref}
      >
        {resultItemLabels.map((label) => {
          switch (label.type) {
            case 'now': {
              return <ProductSearchResultItemNowLabel key={label.type} />
            }
            case 'prescription_medicine': {
              return (
                <ProductSearchResultItemPrescriptionRequiredLabel
                  key={label.type}
                />
              )
            }
            case 'promotion': {
              return (
                <ProductSearchResultItemPromotionLabelRenderer
                  key={label.type}
                  label={label}
                />
              )
            }
            case 'redPointsMultiplier': {
              return (
                <ProductSearchResultItemRedPointsLabel
                  key={label.type}
                  label={label}
                />
              )
            }
            case 'sellerPromotion': {
              return (
                <ProductSearchResultItemSellerPromotionLabel key={label.type} />
              )
            }
            case 'sponsored': {
              return (
                <ProductSearchResultItemSellerSponsoredLabel key={label.type} />
              )
            }
            case 'volumeBasedPricing': {
              return renderVolumeBasedPricingLabel ? (
                <ProductSearchResultItemVolumePricingLabel key={label.type} />
              ) : null
            }
            default: {
              return (
                <ProductSearchResultItemGenericLabel
                  className="border-dark-primary-min bg-light-primary-low"
                  key={label.type}
                >
                  {label.labelText}
                </ProductSearchResultItemGenericLabel>
              )
            }
          }
        })}
      </div>
      {resultItemLabels.length > 0 ? (
        <ProductSearchResultItemCounterLabel
          counterRef={counterRef}
          hiddenLabelsCounter={hiddenLabelsCounter}
        />
      ) : null}
    </div>
  )
}
